import { ApiClientHr } from 'app/service/api-service'
import { JobTitleEndPoint } from './constant'
export const requestGetAllJobTitleGroup = params =>
  ApiClientHr.Get({
    url: `${JobTitleEndPoint.JobTitle.requestGetAll}`,
    params: params,
  })
